<template>
  <div class="bg-primary-account mt-24">
    <div class="container py-21 grid gap-6">
      <img
        v-if="bannerPromotionStore.promotionImage"
        :src="bannerPromotionStore.promotionImage"
        alt="Promotion"
        class="w-full h-auto object-cover"
      />
    </div>
  </div>
</template>

<script setup>
import { usePromotionStore } from "@/stores/bannerPromotionStore";
import { onMounted } from "vue";

const bannerPromotionStore = usePromotionStore();

onMounted(() => {
  bannerPromotionStore.fetchPromotionImage();
});
</script>
